<template>
    <v-data-table
        dense
        :headers="headers"
        :items="itemAccounts"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-sort
    >
    <template v-slot:[`item.actions`]="{item}">
        <v-btn icon color="primary" @click="handleEdit(item)">
            <v-icon>mdi-pencil</v-icon>
        </v-btn>
    </template>

    </v-data-table>
</template>

<script>
export default {
    name: "ItemAccountList",
    props: {
        data: Object,
        loading: Boolean
    },
    data() {
        return {
            headers: [
                { text: "Account", value: "display_name"},
                { text: "Type", value: "item_account_type_code"},
                { text: "", value: "actions" }
            ]
        }
    },
    computed: {
        itemAccounts() {
            if(!this.data) return [];
            return this.data.accounts;
        }
    },
    methods: {
        handleEdit(item) {
            this.$router.push({ name: "ItemAccountEdit", params: { id: this.data.id, accountId: item.id }})
        }
    }
}
</script>

<style>
</style>